/**
 * App Banner JS
 * Handles the in-page [bfwt_app_banner] shortcode widget dismiss/show logic.
 */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  function initBanner(config) {
    const banner = document.querySelector(config.bannerId);
    if (!banner) return;

    const closeBtn = document.querySelector(config.closeBtnId);
    const storageKey = config.storageKey;
    const dismissDuration = config.dismissDuration || 24 * 60 * 60 * 1000; // Default 1 day

    // Check state
    let dismissedTimestamp = null;
    try {
      dismissedTimestamp = localStorage.getItem(storageKey);
    } catch (e) {}
    if (dismissedTimestamp) {
      const timeSinceDismissed = Date.now() - parseInt(dismissedTimestamp, 10);
      if (timeSinceDismissed < dismissDuration) {
        banner.style.display = 'none';
        return;
      }
    }

    // Show banner
    banner.style.display = 'block';
    if (config.onShow) config.onShow(banner);
    banner.classList.add('is-visible');

    // Handle Close
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof window.bfwt_trackEvent === 'function') {
          window.bfwt_trackEvent('app_banner_dismiss', {
            event_category: 'engagement',
          });
        }
        try {
          localStorage.setItem(storageKey, Date.now().toString());
        } catch (e) {}

        banner.classList.remove('is-visible');
        banner.classList.add('is-hiding');

        setTimeout(function () {
          banner.style.display = 'none';
        }, 500);
      });
    }

    // CTA click (store links inside banner)
    banner.addEventListener('click', function (e) {
      const link = e.target.closest(
        'a[href*="play.google.com"], a[href*="apps.apple.com"]'
      );
      if (link && typeof window.bfwt_trackEvent === 'function') {
        const store =
          (link.getAttribute('href') || '').indexOf('play.google.com') !== -1
            ? 'android'
            : 'ios';
        window.bfwt_trackEvent('app_banner_click', {
          store: store,
          event_category: 'conversion',
        });
      }
    });
  }

  // In-Page App Widget (Shortcode)
  initBanner({
    bannerId:
      '.bfwt-app-banner-container:not(.bfwt-app-banner-container--modal) .bfwt-app-promo-glass',
    closeBtnId: '#bfwt-app-banner-close',
    storageKey: 'bfwtAppBannerDismissedTimestamp',
    dismissDuration: 24 * 60 * 60 * 1000, // 1 Day
  });

  // Exit Intent Modal Logic
  function initExitIntent() {
    const popup = document.getElementById('bfwt-exit-intent-popup');
    if (!popup) return;

    const closeBtn = document.getElementById('bfwt-app-banner-modal-close');
    const storageKey = 'bfwtExitIntentDismissedTimestamp';
    const dismissDuration = 7 * 24 * 60 * 60 * 1000; // 7 Days Frequency Cap

    let popupShown = false;

    // Check if user dismissed it recently
    function shouldShow() {
      let dismissedTimestamp = null;
      try {
        dismissedTimestamp = localStorage.getItem(storageKey);
      } catch (e) {}
      if (dismissedTimestamp) {
        const timeSinceDismissed =
          Date.now() - parseInt(dismissedTimestamp, 10);
        if (timeSinceDismissed < dismissDuration) {
          return false;
        }
      }
      return true;
    }

    function showPopup() {
      if (popupShown || !shouldShow()) return;

      popup.style.display = 'flex';
      document.body.classList.add('bfwt-popup-is-open');

      // Force layout calculation for animation transitions
      popup.offsetHeight;

      popup.classList.add('show');
      popupShown = true;

      if (typeof window.bfwt_trackEvent === 'function') {
        window.bfwt_trackEvent('exit_intent_show', {
          event_category: 'engagement',
        });
      }
    }

    function dismissPopup() {
      popup.classList.remove('show');
      try {
        localStorage.setItem(storageKey, Date.now().toString());
      } catch (e) {}

      if (typeof window.bfwt_trackEvent === 'function') {
        window.bfwt_trackEvent('exit_intent_dismiss', {
          event_category: 'engagement',
        });
      }

      setTimeout(function () {
        popup.style.display = 'none';
        if (
          document.querySelectorAll('.bfwt-popup-overlay.show').length === 0
        ) {
          document.body.classList.remove('bfwt-popup-is-open');
        }
      }, 300);
    }

    // Trigger on cursor leaving viewport from the top
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 20) {
        showPopup();
      }
    });

    // Close button click listener
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        dismissPopup();
      });
    }

    // Click outside overlay dismiss
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        dismissPopup();
      }
    });

    // Track app CTA link clicks in the modal
    const modalBanner = popup.querySelector('.bfwt-app-promo-glass');
    if (modalBanner) {
      modalBanner.addEventListener('click', function (e) {
        const link = e.target.closest(
          'a[href*="play.google.com"], a[href*="apps.apple.com"]'
        );
        if (link && typeof window.bfwt_trackEvent === 'function') {
          const store =
            (link.getAttribute('href') || '').indexOf('play.google.com') !== -1
              ? 'android'
              : 'ios';
          window.bfwt_trackEvent('exit_intent_click', {
            store: store,
            event_category: 'conversion',
          });
        }
      });
    }
  }

  initExitIntent();
});
